import { type SoilPropertyOrigin } from "consts";

// Never GEE/reference-data sourced, regardless of version — pure model output.
const MODEL_ONLY_KEYS = new Set([
  "sp_earthwormDensity",
  "tillage_porosity",
  "sp_surfaceResidues",
  "sp_weedSeedDensity",
  "sp_surfaceSealing",
  "sp_cropNRequirement",
  "sp_cropPhPreference",
  "sp_cropGrowingDegreeDays",
  "sp_cropMoistureRequirements",
  "sp_cropRootingDepth",
]);

// The subset of geospatial fields v5 fills from /reference-data/soil (mergeReferenceSoil on the API).
const V5_REFERENCE_DATA_KEYS = new Set(["sp_sand", "sp_silt", "sp_clay", "sp_slope", "sp_rootingDepth", "sp_baseSaturation", "sp_availableNitrogen"]);

// The subset of geospatial fields v5 instead gets from its own model output.
const V5_MODEL_KEYS = new Set(["sp_ph", "sp_carbon", "sp_totalNitrogen", "sp_bulkDensity", "sp_structure"]);

// v5-only fields with no v3/v4 equivalent at all — not part of the 17-field geospatial group, since
// there's nothing for v3/v4 to have sourced from GEE in the first place.
const V5_ONLY_MODEL_KEYS = new Set(["sp_nutrientAvailability", "sp_biodiversity", "sp_nutrientCycling"]);

const isV5 = (version: string | null | undefined): boolean => !!version && version.replace(/^v/i, "").startsWith("5");

export function soilPropertyOrigin(key: string, version: string | null | undefined): SoilPropertyOrigin {
  if (MODEL_ONLY_KEYS.has(key)) return "model";
  if (V5_ONLY_MODEL_KEYS.has(key)) return isV5(version) ? "model" : "unavailable";
  if (!isV5(version)) return "gee";
  if (V5_REFERENCE_DATA_KEYS.has(key)) return "reference-data";
  if (V5_MODEL_KEYS.has(key)) return "model";
  return "unavailable";
}
